import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { WORLD_CUP_WELCOME_ROOT_Z_INDEX } from './WorldCupWelcomeScreen.constants';

export interface WorldCupWelcomeScreenStyleOptions {
  bottomInset?: number;
  topInset?: number;
  rightInset?: number;
}

export const getWorldCupWelcomeScreenStyles = (
  theme: Theme,
  opts?: WorldCupWelcomeScreenStyleOptions,
) => {
  const topInset = opts?.topInset ?? 0;
  const rightInset = opts?.rightInset ?? 0;
  return StyleSheet.create({
    root: {
      ...StyleSheet.absoluteFillObject,
      zIndex: WORLD_CUP_WELCOME_ROOT_Z_INDEX,
      elevation: 32,
      backgroundColor: theme.background.primary,
      paddingTop: topInset,
      paddingBottom: opts?.bottomInset ?? 0,
      flexDirection: 'column',
      ...(Platform.OS === 'web' && {
        position: 'fixed' as never,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%' as never,
        /** Match menu overlay: stable viewport height (Brave / mobile URL bar). */
        height: 'var(--app-dvh, 100dvh)' as never,
        minHeight: 'var(--app-dvh, 100dvh)' as never,
        maxHeight: 'var(--app-dvh, 100dvh)' as never,
        overscrollBehavior: 'none' as never,
        overscrollBehaviorY: 'none' as never,
        touchAction: 'manipulation' as never,
      }),
    },
    phaseAnimated: {
      flex: 1,
      /** Web: default flex min-height:auto prevents child ScrollView from getting a bounded height. */
      ...(Platform.OS === 'web' && {
        minHeight: 0 as never,
        flexBasis: 0 as never,
      }),
    },
    skipWrap: {
      position: 'absolute',
      zIndex: WORLD_CUP_WELCOME_ROOT_Z_INDEX + 20,
      top: topInset + 4,
      right: rightInset + 4,
    },
    skipPressable: {
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      borderRadius: theme.borderRadius.md,
      ...(Platform.OS === 'web' && { cursor: 'pointer' as never }),
    },
    skipPressableHovered: {
      opacity: 0.85,
    },
    skipPressablePressed: {
      opacity: 0.7,
    },
    skipLabel: {
      fontSize: theme.typography.label.fontSize,
      fontWeight: '700',
      color: theme.gray[600],
    },
  });
};
